<template>
  <supply-demand type="demand"></supply-demand>
</template>
<script>
import supplyDemand from "./index";
export default {
  components: {
    supplyDemand,
  },
};
</script>